module.exports = __webpack_public_path__ + "static/img/img_ai@2x.0ab5db0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_ai@2x.png
// module id = Bjvs
// module chunks = 0